import { Guid } from '../helpers/guid';
import { paginateDataAsync } from '../helpers/paginate-data';
import { SelectionMode, PanelType } from '../../fluent';
import React from 'react';
import { DataTable } from './DataTable';
import { StandarDataTableItem } from './StandarDataTableItem';
export class StandarDataTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: props.items || [],
            selectedItem: undefined,
            commandBarItems: this._buildCommandBar(undefined),
            showPanel: false
        };
    }
    componentDidMount() {
        var _a;
        (_a = this.dtRef) === null || _a === void 0 ? void 0 : _a.refreshTable();
    }
    componentWillReceiveProps(props) {
        this.setState({
            items: props.items || []
        });
    }
    render() {
        return React.createElement(React.Fragment, null,
            React.createElement(DataTable, { onSelectedRow: this._onSelectedRow.bind(this), selectionMode: SelectionMode.single, columns: this.props.columns, title: this.props.tableTitle, commandBarItems: this.state.commandBarItems, ref: (e) => this.dtRef = e, titleClassName: 'ms-fontSize-l', onDownloadServerData: (request) => {
                    return paginateDataAsync(request, {
                        data: () => this.state.items || [],
                        order: ['Text', 'Icon'],
                        search: () => this.props.searchColumns || []
                    });
                } }),
            React.createElement(StandarDataTableItem, { model: this.state.selectedItem, readonly: this.props.readonly || false, onChange: item => this.setState({ selectedItem: item }), onClose: () => {
                    this.setState({
                        showPanel: false,
                        selectedItem: undefined
                    }, () => { var _a; return (_a = this.dtRef) === null || _a === void 0 ? void 0 : _a.refreshTable(); });
                }, show: this.state.showPanel, onAccept: item => {
                    const items = this.state.items.slice();
                    const index = items.findIndex(o => o.Id === item.Id);
                    if (index >= 0) {
                        items[index] = item;
                    }
                    else {
                        items.push(item);
                    }
                    this.setState({ items }, () => {
                        var _a;
                        this.props.onChangeItems(items);
                        (_a = this.dtRef) === null || _a === void 0 ? void 0 : _a.refreshTable();
                    });
                }, onRender: (onChange) => this.props.onRenderItemPanel(this.state.selectedItem, onChange), title: this.props.panelTitle, panelType: this.props.panelType || PanelType.medium }));
    }
    refresh() {
        var _a;
        (_a = this.dtRef) === null || _a === void 0 ? void 0 : _a.refreshTable();
    }
    _onSelectedRow(items) {
        this.setState({
            commandBarItems: this._buildCommandBar(items[0]),
            selectedItem: items[0]
        });
    }
    ;
    _buildCommandBar(selectedItem) {
        const getNewGuid = () => {
            let guid = Guid.NewGuid();
            while (this.state.items.find(o => o.Id === guid) != null) {
                guid = Guid.NewGuid();
            }
            return guid;
        };
        const items = [];
        if (this.props.readonly) {
            if (selectedItem != null) {
                items.push({
                    key: 'Editar',
                    name: 'Ver',
                    iconProps: { iconName: 'View' },
                    onClick: () => {
                        this.setState({
                            selectedItem,
                            showPanel: true
                        });
                    }
                });
            }
        }
        else {
            items.push({
                key: 'Agregar',
                name: 'Agregar',
                iconProps: { iconName: 'Add' },
                onClick: () => {
                    this.setState({
                        showPanel: true,
                        selectedItem: { Id: getNewGuid() }
                    });
                }
            });
            if (selectedItem != null) {
                items.push({
                    key: 'Editar',
                    name: 'Editar',
                    iconProps: { iconName: 'Edit' },
                    onClick: () => {
                        this.setState({
                            selectedItem,
                            showPanel: true
                        });
                    }
                });
                items.push({
                    key: 'Eliminar',
                    name: 'Eliminar',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        const items = this.state.items.slice();
                        const index = items.findIndex(o => o.Id === selectedItem.Id);
                        items.splice(index, 1);
                        this.setState({ items }, () => {
                            var _a;
                            this.props.onChangeItems(items);
                            (_a = this.dtRef) === null || _a === void 0 ? void 0 : _a.refreshTable();
                        });
                    }
                });
            }
        }
        return items;
    }
}
